var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearchBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7794 17.2379C12.1353 20.1565 6.80108 19.9268 3.423 16.5487C-0.201548 12.9242 -0.201548 7.04763 3.423 3.42307C7.04756 -0.20148 12.9241 -0.201479 16.5487 3.42307C19.9267 6.80115 20.1565 12.1354 17.2378 15.7795L24.3268 22.8685C24.7296 23.2712 24.7296 23.9242 24.3268 24.3269C23.9241 24.7296 23.2711 24.7296 22.8684 24.3269L15.7794 17.2379ZM4.88141 15.0903C2.06232 12.2712 2.06232 7.70058 4.88141 4.88148C7.70051 2.06238 12.2712 2.06238 15.0903 4.88148C17.9073 7.69851 17.9094 12.2645 15.0965 15.0841C15.0944 15.0862 15.0923 15.0882 15.0902 15.0903C15.0882 15.0924 15.0861 15.0944 15.0841 15.0965C12.2645 17.9094 7.69844 17.9074 4.88141 15.0903Z",
    fill: "#7EC9FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearchBlue);
export default __webpack_public_path__ + "static/media/icon_search_blue.d7492f1af52ffff73bea1c61a43f1403.svg";
export { ForwardRef as ReactComponent };